import { MAX_PLAYERS } from '../config/gameConfig';

class ValidationService {
    // Define valid art styles
    validArtStyles = [
        'expression',
        'abstract',
        'surreal',
        'naive',
        'minimal',
        'anime',
        'ink',
        'random'
    ];

    validatePrompt(prompt) {
        const trimmedPrompt = prompt?.trim() || '';
        const minLength = 3;
        const maxLength = 100;

        return {
            isValid: trimmedPrompt.length >= minLength && trimmedPrompt.length <= maxLength,
            message: !trimmedPrompt
                ? 'Prompt is required'
                : trimmedPrompt.length < minLength
                    ? `Prompt must be at least ${minLength} characters long`
                    : trimmedPrompt.length > maxLength
                        ? `Prompt must be less than ${maxLength} characters`
                        : ''
        };
    }

    validateGuess(guess) {
        const trimmedGuess = guess?.trim() || '';
        const minLength = 1;
        const maxLength = 100;

        return {
            isValid: trimmedGuess.length >= minLength && trimmedGuess.length <= maxLength,
            message: !trimmedGuess
                ? 'Guess is required'
                : trimmedGuess.length > maxLength
                    ? `Guess must be less than ${maxLength} characters`
                    : ''
        };
    }

    validateRoomCode(code) {
        const trimmedCode = code?.trim() || '';
        const validFormat = /^[A-Za-z0-9]{6}$/;

        return {
            isValid: validFormat.test(trimmedCode),
            message: !trimmedCode
                ? 'Room code is required'
                : !validFormat.test(trimmedCode)
                    ? 'Room code must be 6 characters long and contain only letters and numbers'
                    : ''
        };
    }

    validateGameSettings(settings) {
        const validations = {
            maxPlayers: {
                isValid: settings.maxPlayers >= 2 && settings.maxPlayers <= MAX_PLAYERS,
                message: `Max players must be between 2 and ${MAX_PLAYERS}`
            },
            roundTime: {
                isValid: settings.roundTime >= 30 && settings.roundTime <= 120,
                message: 'Round time must be between 30 and 120 seconds'
            },
            maxRounds: {
                isValid: settings.maxRounds >= 5 && settings.maxRounds <= 20,
                message: 'Max rounds must be between 5 and 20'
            }
        };

        const isValid = Object.values(validations).every(v => v.isValid);
        const messages = Object.entries(validations)
            .filter(([_, v]) => !v.isValid)
            .map(([_, v]) => v.message);

        return {
            isValid,
            messages,
            validations
        };
    }

    validateArtStyle(style) {
        return {
            isValid: this.validArtStyles.includes(style),
            message: !style
                ? 'Art style is required'
                : !this.validArtStyles.includes(style)
                    ? 'Invalid art style selected'
                    : ''
        };
    }

    sanitizeInput(input) {
        if (typeof input !== 'string') return '';
        return input
            .trim()
            .replace(/[<>]/g, '') // Remove potential HTML tags
            .slice(0, 1000); // Reasonable maximum length
    }
}

export default ValidationService; 